import React from 'react'
import "./WhereToSell.css"
import { useNavigate } from 'react-router-dom'


export default function WhereToSell() {
  const navigate = useNavigate();
  const handlePostAd = () => { 
    navigate('/postAd');
  }
  return (
    <div className='WhereToSell'>
      <img src="/images/bookbackground.jpg" className='bookbackground' alt="bookBackground" />
      <div className="WhereToSellInfo">
        <div className="whereToSellContainer">
          <h2>Where To Sell Used Second Hand Books?</h2>
          <p>Post an Ad now and one of you will be lucky to have your ad featured. Featured Ad gets more buyer interaction.</p>
        </div>
        <div className="WhereToSellInfoBtn">
          <button className='postAdBtn' onClick={handlePostAd} >Post Free Ad <i className="fa-solid fa-angles-right"></i></button>
        </div>
      </div>
    </div>
  )
}
